import React, { useEffect, useState } from "react";
import "./header.css";
import Logo from "../../../../../assets/images/vct_technologies_logo_dark.png";
import LogoLight from "../../../../../assets/images/vct_technologies_logo.png";
import AccountOpening from "../../../../../assets/images/account_opening_nav.svg";
import FundsApproval from "../../../../../assets/images/funds_approval_nav.svg";
import OMS from "../../../../../assets/images/trading_nav.svg";
import Dashboard from "../../../../../assets/images/dashboard_nav.svg";
import Profile from "../../../../../assets/images/profile_nav.svg";
import Signout from "../../../../../assets/images/logout_nav.svg";
import Fix from "../../../../../assets/images/fix.svg";
import JournalAPI from "../../../../../assets/images/journal-api.svg";

import { Link, useNavigate } from "react-router-dom";
import { IsAuthenticated } from "../../../../../helpers";
import { Logout } from "../../../../../api-services";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useDispatch, useSelector } from "react-redux";
import MobileNav from "../../MobileNav";

function Header() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user_data } = useSelector((state) => state.authentication);
  const isAuthenticated = IsAuthenticated();
  const [authStatus, setAuthStatus] = useState(false);
  const firstName = user_data?.customer?.firstName || "";
  const lastName = user_data?.customer?.lastName || "";
  const fullName = `${firstName} ${lastName}`;

  useEffect(() => {
    setAuthStatus(isAuthenticated);
  }, []);

  const handleNavigation = (path) => () => navigate(path);

  const renderApiButton = (apiName, apiDescription, imgSrc) => (
    <li className="d-flex">
      <img
        src={imgSrc}
        alt={`${apiName} API`}
        className="img-fluid pt-1"
        width={30}
        height={30}
      />
      <button
        className="dropdown__link"
        onClick={handleNavigation(
          authStatus ? "/products" : "/authentication/sign-up"
        )}
      >
        <span className="nav-title"> {apiName} </span>
        <span className="nav-desc">{apiDescription}</span>
      </button>
    </li>
  );

  const images = {
    Logo,
    LogoLight,
    AccountOpening,
    FundsApproval,
    OMS,
    Dashboard,
    Profile,
    Signout,
    Fix,
    JournalAPI,
  };

  return (
    <div className="wrap-header-inside">
      <div className="container">
        <div className="row">
          <nav className="navbar d-none d-lg-block">
            <div className="navbar__inner container-fluid">
              <div className="navbar__items">
                <Link to="/" className="navbar-brand">
                  <img src={Logo} alt="VCT Technologies LLC" />
                </Link>
              </div>
              <div className="navbar__items navbar__items--right col-4">
                <div className="row justify-content-md-right">
                  <div className="navbar__item dropdown dropdown--hoverable show col-5 pt-1 text-end">
                    <Link to="#" className="navbar__link">
                      API Offerings
                    </Link>
                    <ul className="dropdown__menu dropdown-menu api-offerings">
                      {renderApiButton(
                        "Account Opening API",
                        "Onboard new users",
                        AccountOpening
                      )}
                      {renderApiButton(
                        "Funding API",
                        "Custom workflows",
                        FundsApproval
                      )}
                      {renderApiButton(
                        "Trading API",
                        "Trade equities, options, monitor positions",
                        OMS
                      )}
                      {renderApiButton(
                        "FIX Specifications",
                        "Harness the power of our FIX infrastructure in your products",
                        Fix
                      )}
                      {renderApiButton(
                        "Journal API",
                        "The Journal Entry API creates a CSV file, submits it to InteliClear, and emails relevant recipients.",
                        JournalAPI
                      )}
                    </ul>
                  </div>
                  <div
                    className={`navbar__item dropdown dropdown--hoverable ${
                      authStatus ? "col-7" : "col-3"
                    } p-0 pt-1 text-center`}
                  >
                    {authStatus ? (
                      <>
                        <div className="wrap-name">
                          <AccountCircleIcon
                            className="me-2 mb-1 text-dark"
                            fontSize="medium"
                          />
                          <Link to="#" className="navbar__link">
                            {fullName}
                          </Link>
                        </div>
                        <ul className="dropdown__menu dropdown-menu af-signin">
                          <li>
                            <img
                              src={Dashboard}
                              alt="Dashboard"
                              className="img-fluid mb-2"
                              width={32}
                              height={32}
                            />
                            <button
                              className="dropdown__link"
                              onClick={handleNavigation("/dashboard")}
                            >
                              Dashboard
                            </button>
                          </li>
                          <li>
                            <img
                              src={Profile}
                              alt="Profile"
                              className="img-fluid mb-2"
                              width={32}
                              height={32}
                            />
                            <button
                              className="dropdown__link"
                              onClick={handleNavigation("/profile")}
                            >
                              Profile
                            </button>
                          </li>
                          <li>
                            <img
                              src={Signout}
                              alt="Signout"
                              className="img-fluid mb-2"
                              width={32}
                              height={32}
                            />
                            <button
                              className="dropdown__link"
                              onClick={() => Logout(dispatch, navigate)}
                            >
                              Sign Out
                            </button>
                          </li>
                        </ul>
                      </>
                    ) : (
                      <button
                        className="navbar__link"
                        onClick={handleNavigation("/authentication/sign-in")}
                      >
                        Sign In
                      </button>
                    )}
                  </div>
                  {!authStatus && (
                    <div className="navbar__item dropdown dropdown--hoverable col-4 p-0">
                      <button
                        className="btn btn-reg inside"
                        onClick={handleNavigation("/authentication/sign-up")}
                      >
                        Register
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </nav>
          <MobileNav images={images} />
        </div>
      </div>
    </div>
  );
}

export default Header;
